import React from 'react';
import loadable from '@loadable/component';

import requireLoggedInSaga from 'routes/helpers/requireLoggedIn';
import requireMembershipSaga from 'routes/helpers/requireMembershipStatus';
import { redirectTo } from 'helpers/path';
import { memberStatus } from 'enums/memberStatus';
import { checkWinbackOfferPermissionSaga } from './Rejoin.saga';

const Root = loadable(() => import('./Root'));
const FlowContainer = loadable(() => import('./FlowContainer'));
const OfferFlowContainer = loadable(() => import('./OfferFlowContainer'));
const Success = loadable(() => import('./Success'));

export const ReactivationRoute = (store, client) => {
  const requireEligible = (nextState, replaceState, cb) =>
    store
      .runSagaOnce(checkWinbackOfferPermissionSaga, client, replaceState, null, '/reactivate/checkout')
      .toPromise()
      .then(cb, cb);

  const redirectToRejoin = (nextState, replaceState, cb) =>
    redirectTo(`/rejoin${nextState.location.search}`)(nextState, replaceState, cb);

  return {
    path: 'reactivate',

    onEnter: (nextState, replaceState, cb) =>
      store
        .runSagaOnce(requireLoggedInSaga, nextState, replaceState)
        .toPromise()
        .then(() =>
          store.runSagaOnce(requireMembershipSaga, client, replaceState, [memberStatus('CANCELLED')]).toPromise()
        )
        .then(cb),

    component: props => <Root {...props} />,

    indexRoute: {
      // route deprecated and should use the rejoin pages instead
      onEnter: redirectToRejoin,
    },

    childRoutes: [
      {
        path: 'checkout',
        component: props => <FlowContainer {...props} />,
      },
      {
        // 20190102 - Sai - deprecated
        // we no longer support the /reactivate/start route
        // as the full fare checkout page due to hard coding
        // of this route in the mobile apps. Instead, we want
        // this to redirect to the /rejoin route which will
        // always have the current reactivation winback offer.
        // The full fare reactivation checkout page is changed
        // to /reactivate/checkout
        path: 'start',
        onEnter: redirectToRejoin,
      },
      {
        // only allow
        // - logged in + churned + eligible
        path: 'offer/:promoAlias',
        component: props => <OfferFlowContainer {...props} />,
        onEnter: requireEligible,
      },
      {
        path: 'success',
        component: props => <Success {...props} />,
      },
    ],
  };
};
